enum CanvasSharedPolicy {
	NotShared = 1,
	SharedAuth = 2,
	SharedSlideUnAuth = 3,
	SharedModuleUnAuth = 4,
}

export default CanvasSharedPolicy;
